import PropTypes from "prop-types";
import React, { useState } from "react";

import { ThickBanner, ThemeSelector } from "@theconversation/ui";

/**
 * The `DesktopBanner` component represents the top banner that appears
 * on desktops only.
 */
function DesktopBanner({ body, donateText, buttonText, onClick, onClose, color, theme }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  // Some promos are using donateText, which is a bit too linked
  // to only donations. Until we can end other promo campaigns,
  // we should support `donateText` until we can only support `buttonText`
  const btnText = donateText || buttonText;

  return (
    <ThemeSelector theme={theme}>
      <ThickBanner
        buttonText={btnText}
        color={color}
        onClose={handleClose}
        onClick={onClick}
        open={open}
      >
        {body}
      </ThickBanner>
    </ThemeSelector>
  );
}

DesktopBanner.propTypes = {
  body: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  color: PropTypes.string,
  donateText: PropTypes.string,
  theme: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

DesktopBanner.defaultProps = {
  color: "primary",
  theme: "core",
  donateText: "",
  buttonText: "",
};

export default DesktopBanner;
